export default "__VITE_ASSET__CuGgHV2G__"